import React from 'react';
import { MultilineErrorList, MultilineErrorContainer } from './MultilineError.styled';

interface Props {}

const MultilineError: React.FC<Props> = () => {
  return (
    <MultilineErrorContainer>
      <p>Sorry, your log in attempt failed due to one of the following:</p>
      <MultilineErrorList>
        <li>- Incorrect email address</li>
        <li>- Incorrect password</li>
        <li>- No registered account</li>
      </MultilineErrorList>
    </MultilineErrorContainer>
  );
};

export default MultilineError;
